//searchFilter

import Button from "components/Button/Button";
import Logo from "components/Logo/Logo";
import styled from "styled-components";

export { TooltipContent } from "components/Filters/Filters.styles";

export const FilterLogo = styled(Logo)`
  margin-right: 10px;
`;

export const AddNewButton = styled(Button)`
  margin-left: 10px;
  text-transform: capitalize;
`;

export const AddNewMobileButton = styled(Button)`
  text-transform: capitalize;
`;
